import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import React from "react";
import { Host } from "../../models/hostModel";
import locationsService from "services/locationsService";
import {
  Grid,
  Card,
  MenuItem,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  CircularProgress,
} from "@mui/material";
import MDBox from "mdComponents/MDBox";
import MDTypography from "mdComponents/MDTypography";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import MDInput from "mdComponents/MDInput";
import MDButton from "mdComponents/MDButton";
import LocationHours from "controls/LocationHours";
import LocationDoorLockHours from "controls/LocationDoorLockHours";
import Switch from "@mui/material/Switch";
import { amenityKeyMap, states, amenitiesList, BACKEND_BASE_URL, HOST_PRICING_PLANS, MESSAGES_VALIDATION, MESSAGES_ERROR, MESSAGES_ADDRESS_VERIFICATION } from "../../constants";
import GoingWorkflowService from "services/goingWorkflowService";
import ClearLocationModal from "components/Modals/ClearLocationModal";
import { useHostPortalContext } from "context/HostPortalContext";
import { useNavigationMessageContext } from "context/NavigationMessageContext";
import RemoveLocationModal from "components/Modals/RemoveLocationModal";
import { getCurrentSessionToken } from "services/auth";
import MDAlert from "mdComponents/MDAlert";
import LocationChangeSubscriptionPlanModal from "controls/LocationChangeSubscriptionHostingPlan";
import LocationHostAdminDetailsModal from "controls/LocationHostAdminDetailsModal";
import CorporateAdminList from "controls/CorporateAdminsList";
import corporateAccountService from "services/corporateAccountService";
import { LocationHostUser } from "../../models/locationHostUserModel";
import { useUser } from "context/UserContext";
import CorporateRatings from "controls/CorporteRatings";
import CorporateROI from "controls/CorporateROI";
import CorporateVisits from "controls/CorporateVisits";
import CorporateHostPerformance from "controls/CorporatePerformance";
import CorporateDoorLockIssues from "controls/CorporateDoorLockIssues";
import CorporatePoorConditionReports from "controls/CorporatePoorConditionReportCount";
import { validatePhone } from "Utils";
import googleAPIService from "services/googleAPIService";
import { parseAddress } from "Utils";
import exceptionService from "services/exceptionService";
import AddressPickerModal from "components/Modals/AddressPickerModal";
import AddressNotBusinessVerifyModal from "components/Modals/AddressVerifyModal";
import { formatPhoneNumber } from "Utils";
import { useAlertContext } from "context/AlertContext";

const ViewLocation = () => {
  const { id } = useParams<{ id: string }>();
  const { userCorporateAccount} = useUser();
  const { host , setHost } = useHostPortalContext();
  const { setMessage } = useNavigationMessageContext();
  const { setAlert } = useAlertContext();
  const navigate = useNavigate();
  const [reloadCorporatePerformanceKey, setReloadCorporatePerformanceKey] = useState<number>(0);
  const [showClearLocationModal, setShowClearLocationModal] = useState(false);
  const [showRemoveLocationModal, setShowRemoveLocationModal] = useState<boolean>(false);
  const [showLocationChangeSubscriptionPlanModal, setShowLocationChangeSubscriptionPlanModal] = useState<boolean>(false);    
  const [showLocationAdminDetailsModal, setShowLocationAdminDetailsModal] = useState<boolean>(false);    
  const [locationHostUsers, setLocationHostUsers] = useState<LocationHostUser[]>();
  const [saving, setSaving] = useState(false);
  const [loadingHostUsers, setLoadingHostUsers] = useState(true);
  const [showItemDetails, setShowItemDetails] = useState(false);
  const [showNewItem, setShowNewItem] = useState(false);
  const [viewingItem, setViewingItem] = useState<LocationHostUser>();

  const [updatingHostingPlan, setUpdatingHostingPlan] = useState<boolean>(false);

  const [cancelingMembership, setCancelingMembership] = useState(false);
  const [clearingRestroom, setClearingRestroom] = useState(false);
  const [showAddressNotBusinessVerifyModal, setShowAddressNotBusinessVerifyModal] = useState(false);
  const [showAddressPickerModal, setShowAddressPickerModal] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [addressesForPicker, setAddressesForPicker] = useState<any[]>([]);
  const [addressPicked, setAddressPicked] = useState<number | null>(null);
  const [addressConfirmed, setAddressConfirmed] = useState(false);
  const [verifingAddress, setVerifingAddress] = useState<boolean>(false);
  
  //if the host was not set in context, fetch it
  useEffect(() => {
    if (id && !host) {
      const hostId = parseInt(id, 10);
      locationsService.getHostRecord(hostId).then((data) => {
        setHost(data);
      });
    }
  }, [id]);

  useEffect(() => {    
        setMessage(`${host?.name} Hosting Location`);
        return () => setMessage(undefined);
  },[host]);

  const goToLocationActivity = () => {
    if (!host?.id) return;
    navigate(`/location/activity/${host.id}`);
  };

  if (!host) {
    return (
      <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6} justifyContent="center">
          <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
            <Card sx={{ p: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>
              <CircularProgress sx={{ color: "#21b2a6", width: 40, height: 40 }} />
              <MDTypography variant="h6" fontWeight="medium" mt={2}>
                Loading Location...
              </MDTypography>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    );
  }
    const handleClearRestroomConfirm  = async () => {
      const result = await GoingWorkflowService.clearLocationWorkflows(host.id);
      setClearingRestroom(true);
      if(result){
        setAlert("success", "Restroom status cleared. It is now available for app users.");
      }else{
        setAlert('error', 'There was an error clearing the restroom status. Please try again.');
      }
        setClearingRestroom(false);
        setShowClearLocationModal(false);
    };
  
  const handleClearRestroomCancel = () => {
    setShowClearLocationModal(false);
  };
  
    const toggleClosedForCleaning = async () => {
        const result = await locationsService.updateOpenCloseLocation(host.id, !host.closedForCleaning);
        if(result){ 
            setHost((prev) => ({
                ...prev,
                closedForCleaning: !prev.closedForCleaning,
            }) as Host);
            setAlert(host.closedForCleaning ? "success" : "warning", 
                        !host.closedForCleaning ? "Location is now closed for cleaning." : "Location has been re-opened.", 
                        !host.closedForCleaning ? "Location Closed" : "Location Re-Opened", 
                        host.closedForCleaning ? "check" : "warning");
            //reload corporate performance control
            setReloadCorporatePerformanceKey(prev => prev + 1);
        }else{
            setAlert("error", "There was an error updating the location status. Please try again.");
        }
    };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* Actions */}
            <MDBox mt={-3} mb={1}>
                <MDBox mt={3} py={1} borderRadius="lg">
                    <MDBox display="flex" flexWrap="wrap" gap={2}>
                        <MDButton color="dark" onClick={() => navigate(`/location/edit/${host.id}`)}>Manage Location Settings</MDButton>                        
                        <MDButton color="info" onClick={() => goToLocationActivity()}>View Location Activity</MDButton>
                        <MDButton color="info" onClick={() => navigate(`/location/poor-condition-reports/${host.id}`)}>View Poor Condition Reports</MDButton>
                        <MDButton color="info" onClick={() => navigate(`/location/suspended-users/${host.id}`)}>Manage Suspended Users</MDButton>
                        <MDButton color="dark" onClick={() => setShowClearLocationModal(true)}>Clear Restroom</MDButton>
                        <MDButton color={!host.closedForCleaning ? "warning" : "success"} onClick={() => toggleClosedForCleaning()}>{!host.closedForCleaning ? "Close for Cleaning" : "Re-Open after Cleaning"}</MDButton>
                    </MDBox>
                </MDBox>
                    
                  
            </MDBox>
            <ClearLocationModal
                open={showClearLocationModal}
                onConfirm={handleClearRestroomConfirm}
                onCancel={handleClearRestroomCancel}
                clearing={clearingRestroom}
            />

            {!host.isApproved &&
              <MDAlert color="secondary" sx={{
                px: 2,               // optional horizontal padding
                fontSize: '0.85rem', // smaller text
                lineHeight: 1.2,     // tighter lines    
              }}>This location is pending approval. Our team will review your
                submission and contact you shortly to verify your business details.</MDAlert>
                }
            <CorporateHostPerformance limitToId={host?.id} title="Location Status" description={`Current hosting status for ${host?.name ?? 'this location'} at a glance.`} hideBusinessName disableClick reloadKey={reloadCorporatePerformanceKey}/>
            <CorporateROI limitToId={host?.id} description="Calculations are based on a $10 purchase per customer." hideBusinessName disableClick/>
            <CorporateVisits limitToId={host?.id} title="App User Visits" description="Visits recorded at this location. Visits are counted when a user clicks 'Go' at this location. Click to see a list of recent activity." hideBusinessName />
            <CorporateDoorLockIssues limitToId={host?.id} description="Reported by users when the provided door lock does not work or is inaccessible." hideBusinessName disableClick/>
            <CorporatePoorConditionReports limitToId={host?.id} description="Reported by users when the restroom is in poor condition. Click for more details." hideBusinessName />
            <CorporateRatings limitToId={host?.id} title="Location Ratings" description="User ratings for this location." hideBusinessName />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
export default ViewLocation;